import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function AiRecorderSolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("aiRecorder.title")}</title>
        <meta name="keywords" content={t("aiRecorder.keywords")} />
        <meta name="description" content={t("aiRecorder.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#1e1b3a]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/recorder-banner.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_10%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#15122a]/92 via-[#15122a]/72 to-transparent" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("aiRecorder.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("aiRecorder.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("aiRecorder.knowledgeBase.rootLabel")}
        rootColor="#7c3aed"
        treeTranslationKey="aiRecorder.knowledgeBase.tree"
        i18nPrefix="aiRecorder.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="aiRecorder"
        images={{
          painPoints: "/solutions/recorder-pain.jpeg",
          solutions: "/solutions/recorder-solutions.jpeg",
          cta: "/solutions/recorder-cta.jpeg",
        }}
        imagesPos={{ 
          cta: "50% 0%",
          painPoints: "68% 20%",
          solutions: "54.5% 30%",
        }}
      />
    </>
  );
}
